import { Module } from '../utils/_application'

var $ = jQuery;

export default class Print extends Module {

	ready(app) {

		$(document).on('click', '.print', function(e){

			window.print();

			e.preventDefault();

		});

    }
}